import Vue from 'vue'
import Vuex from 'vuex'

import { db } from '@/firebase'

Vue.use(Vuex)

const state = {
  user: null,
  userMeta: null
}

const getters = {
  getUID: state => {
    if (state.user) {
      return state.user.uid
    } else {
      return null
    }
  }
}

const mutations = {
  setUser (state, uid) {
    state.user.uid = uid
    state.user.loggedIn = true
  },
  setUserMeta (state, data) {
    state.userMeta = data
  }
}

const actions = {
  setUser (context, uid) {
    context.commit('setUser', uid)
    db.ref('users/' + uid).once('value').then(function (s) {
      context.commit('setUserMeta', s.val())
    })
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js